import styled from '@emotion/styled';

export const TabsStyle = styled.div<{ directionTabs?: string; directionNav?: string }>`
    label: tabs;

    display: flex;
    flex-direction: ${(props) => props.directionTabs || 'column'};
    margin: 0;
    padding: 0;
    overflow: hidden;

    .tabs-bar {
        position: relative;
        overflow: hidden;

        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1.2rem;
            z-index: 2;
        }
        &::before {
            left: 0;
        }
        &::after {
            right: 0;
        }
    }
    .tabs-nav {
        position: relative;
        display: flex;
        flex: none;
        align-items: center;
        flex: 1 0 auto;
        flex-direction: ${(props) => props.directionNav || 'row'};
        min-width: 50px;
        transition: transform 0.3s;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 0;
        }
    }

    .tabs-tab {
        position: relative;
        /* display: inline-flex; */
        /* align-items: center; */
        padding: 8px 24px;
        text-align: center;
        cursor: pointer;
    }

    .tabs-tab-active {
        color: #f00;
    }

    .tabs-content {
        width: 100%;
    }
`;
